'use es6';

import { OrderedMap } from 'immutable';
import { backfillStagedEncodingsAndOptions, convertStagedFieldsIntoColumns, fixFiltersOnDealCloseDateTreatedAsNumbers, switchToFullyQualifiedName, updateAssociationLabelPropertyName } from './migrate';
import deprecations from './deprecate';
const migrationList = OrderedMap({
  // Promises (run first!)
  convertStagedFieldsIntoColumns,
  switchToFullyQualifiedName,
  updateAssociationLabelPropertyName,
  backfillStagedEncodingsAndOptions,
  fixFiltersOnDealCloseDateTreatedAsNumbers,
  adClickedEventDeprecation: deprecations.adClickedEventDeprecation,
  usesCurrentlyInWorkflowProperty: deprecations.usesCurrentlyInWorkflowProperty,
  singleDealSplitDeprecation: deprecations.singleDealSplitDeprecation
});
const repairSnowflakeReport = (report, userInfo) => {
  if (!report.has('reportDefinition')) {
    return Promise.resolve(report);
  }
  return migrationList.reduce((prev, migration) => prev.then(prevReport => Promise.resolve(migration(prevReport, userInfo)).then(migratedReport => {
    return migratedReport;
  })), Promise.resolve(report));
};
export default repairSnowflakeReport;